export enum ValueType {
  STRING = 'string',
  NUMBER = 'number',
  FLOAT = 'float',
  BOOLEAN = 'boolean',
  OPTION = 'option',
}
